import { ConcreteEncodable } from "./ConcreteEncodable";

import { SessionPurgeEventImplEncoder } from "../../encoder/SessionPurgeEventImplEncoder";

import * as CubiqTS from "../../index";
import { SessionPurgeEvent } from "../SessionPurgeEvent";

export class SessionPurgeEventImpl extends ConcreteEncodable implements SessionPurgeEvent {
  public static enType: string = "com.bcdfx.model.SessionPurgeEventImpl";

  /*FID=1*/
  public userCd: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SessionPurgeEventImplEncoder.Instance;
    this.setEncodableType(SessionPurgeEventImpl.enType);
    //Model
  }

  public toString(): string {
    return "SessionPurgeEventImpl[" + "userCd=" + this.userCd + "messageId=" + this.messageId + "]";
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
